import axios from 'axios'

export const getDashboard = ({ id }) => {
    return axios({
        url: `/gss-dashboard/stream-app`,
        method: `get`,
        params: { id }
    })
}

export const fetchHfCases = function (params) {
    return axios({
        method: `post`,
        url: `/bq/customer-dashboard/fetch-customer-hf-tickets`,
        data: params
    })
}

export const fetchRmaData = function (params) {
    return axios({
        method: `post`,
        url: `/bq/customer-dashboard/fetch-customer-rmas`,
        data: params
    })
}

export const fetchCallLogs = function (params) {
    return axios({
        method: `post`,
        url: `/bq/customer-dashboard/fetch-customer-call-logs`,
        data: params
    })
}

export const fetchPrtgReport = function (params) {
    return axios({
        method: `post`,
        url: `/analytics/customer-dashboard/prtg-report`,
        data: params
    })
}

export function downloadReport(trackId) {
    return axios({
        url: `/bucket-uploader/download-from-gridfs`,
        method: `get`,
        params: trackId,
        responseType: 'blob'
    })
}
